<script setup>
import { ref, computed } from 'vue';
import { __ } from '@/utils';
import Flex from '@components/flex/flex.vue';
import Slider from '@components/slider/slider.vue';
import WhiteBox from '@components/whiteBox/whiteBox.vue';
import Modal from "@components/modal.vue";
import Tabs from '@components/tabs.vue';
import IconTabPhone from '@components/icons/icon-tab-phone.vue';
// import IconTabInternet from '@components/icons/icon-tab-internet.vue';
// import IconTabInternational from '@components/icons/icon-tab-international.vue';
import ActionListGrid from './actionList-grid.vue';
import { useDeviceType } from '@composables/useDeviceType';
import { RouterLink } from 'vue-router';

const { deviceType } = useDeviceType();

const modalGrid = ref(false);

const slides = [
    {
        title: __('update personal details'),
        image: theme_path.url + '/resources/images/svg/icon-personal-details.svg',
        link: '/profile',
        router: true
    },
    // {
    //     title: __('Managing my line'),
    //     image: theme_path.url + '/resources/images/svg/icon-tab-manage-line.svg',
    //     link: '#'
    // },
    // {
    //     title: __('Change of mobile package'),
    //     image: theme_path.url + '/resources/images/svg/icon-tab-change-mobile-package.svg',
    //     link: '#'
    // },
    {
        title: __('Packages abroad'),
        image: theme_path.url + '/resources/images/svg/icon-plane-stars.svg',
        link: '/roaming',
        new_tab: true
    },
    {
        title: __('Call detail'),
        image: theme_path.url + '/resources/images/icon-phone-calls.svg',
        link: '/usages',
        router: true
    },
    // {
    //     title: __('Browsing extension'),
    //     image: theme_path.url + '/resources/images/svg/icon-wifi-plus.svg',
    //     link: '#'
    // },
    {
        title: __('Managing my line'),
        image: theme_path.url + '/resources/images/svg/icon-tab-manage-line.svg',
        link: '/settings',
        router: true
    },
    // {
    //     title: __('Change of mobile package'),
    //     image: theme_path.url + '/resources/images/svg/icon-tab-change-mobile-package.svg',
    //     link: '#'
    // },
]

const tabs = [
	{
		title: 'cellular',
        icon: IconTabPhone,
		body: [
			{ component: ActionListGrid, props: {items: slides} },
		]
	},
    // {
	// 	title: 'internet',
    //     icon: IconTabInternet,
	// 	body: [
	// 		{ component: ActionListGrid, props: {items: slides} },
	// 	]
	// },
    // {
    //     // This title should change to 'סלולרי' on mobile
	// 	title: 'international calls',
    //     icon: IconTabInternational,
	// 	body: [
	// 		{ component: ActionListGrid, props: {items: slides} },
	// 	]
	// },
];

const isMobile = computed(() => deviceType.value === 'mobile');
</script>

<template>
    <div class="action-list">
        <Flex justify="space-between" class="action-list__header">
            <h4>{{ __('quick actions') }}</h4>
            <button type="button" class="action-btn link-underline" @click="modalGrid = true">
                {{ __('for all actions') }}
                <img class="action-btn__arrow" :src="`${theme_path.url}/resources/images/svg/icon-arrow-left-bold.svg`" />
            </button>
        </Flex>
        <Slider v-if="!isMobile"
            slideWidth="220px"
            :options="{
                navigation: true,
                slidesPerView: 'auto',
                spaceBetween: '30px',
                injectStyles: [
                    `
                        .swiper-button-next, 
                        .swiper-button-prev {
                            width: 36px;
                            height: 36px;
                            background: #fff;
                            border-radius: 50%;
                            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
                            color: #000;
                            transform: translateY(-50%);
                        }

                        .swiper-button-next {
                            background: #fff url('${theme_path.url}/resources/images/svg/icon-arrow-left.svg') no-repeat center center;
                        }

                        .swiper-button-prev {
                            background: #fff url('${theme_path.url}/resources/images/svg/icon-arrow-right.svg') no-repeat center center;
                        }
                            
                        .swiper-button-next svg, 
                        .swiper-button-prev svg {
                            display: none;
                        }`
                ]
            }"
            :slides="slides"
        >
            <template v-slot="{slide}">
                <div class="action-list__item">
                    <RouterLink v-if="slide.router" :to="slide.link" class="action-list__link">
                        <WhiteBox>
                            <div class="action-list__link-image">
                                <img :src="slide.image" />
                            </div>
                            <h5>{{ slide.title }}</h5>
                        </WhiteBox>
                    </RouterLink>
                    <a :href="slide.link" class="action-list__link" :target="slide.new_tab ? '_blank' : ''" v-else>
                        <WhiteBox>
                            <div class="action-list__link-image">
                                <img :src="slide.image" />
                            </div>
                            <h5>{{ slide.title }}</h5>
                        </WhiteBox>
                    </a>
                </div>
            </template>
        </Slider>

        <ActionListGrid v-if="isMobile" :items="slides" />

        <Modal class="larger" :isActive="modalGrid" @close="modalGrid = false">
            <template #head>
                <h3>{{ __('The quick actions rule') }}</h3>
            </template>
            <template #body>
                <Tabs :tabs="tabs" class="tabs--line tabs--center mt16" />
            </template>
        </Modal>
    </div>
</template>